import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppServiceHelperService } from '../../../services/app-service-helper.service';

/**
 * VAL Event copy service
 */
@Injectable({
  providedIn: 'root'
})
export class ValuationEventCopyService {
  /**
   * The properties resource URL
   */
  private _valuationEventsResource: string;

  /**
   * Constructor
   */
  constructor(private httpClient: HttpClient, private appServiceHelper: AppServiceHelperService) {
    this._valuationEventsResource = this.appServiceHelper.getServiceEndpoint('pollux.projectValuation.api', 'ValuationPortfolios');
  }

  /**
   * Copies a VE
   * @param portfolioCopyDetails
   * @returns
   */
  copy(portfolioCopyDetails : any) {
    return this.httpClient.post<any>(`${this._valuationEventsResource}/copy`, { portfolioCopyDetails: portfolioCopyDetails });
  }

  /**
   * Loads the valuation periods
   * @param projectId
   * @returns
   */
  getValuationPeriods(projectId: number) {
    return this.httpClient.get<any>(`${this._valuationEventsResource}/valuationPeriods?projectId=${projectId}`);
  }
}
